import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ConfirmationReportTextModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-report-text',
    templateUrl: './confirmation-report-text.component.html',
    styleUrls: ['./confirmation-report-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationReportTextComponent {
    @Input()
    public model: ConfirmationReportTextModel;

    @Input()
    public parentForm: FormArray;
}
